import React from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import NewsWithImage from "../../molecules/NewsWithImage";
import LeftImageRightNews from "../../molecules/LeftImageRightNews";

import { getSlug, getCollectionName } from "../../utils/utils";

import "./fiveVideoStories.m.css";

const FiveVideoStories = ({ collection, sections, domainSlug }) => {
  if (!(collection && collection.items && collection.items.length)) {
    return null;
  }

  const stories =
    collection.items.length > 0 && collection.items.filter((item) => item.type === "story").map((item) => item.story);

  if (stories.length < 0) {
    return null;
  }

  const firstStory = stories.length > 0 && stories[0];
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionSlug = navigateTo ? `/${navigateTo}` : getSlug(collection, sections, domainSlug);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);

  return firstStory ? (
    <div styleName="five-story-5s" className="five-story-5s">
      {showCollectionName && (
        <CollectionTitleWithArrow collectionName={collectionName} collectionSlug={collectionSlug} />
      )}
      {firstStory && (
        <LeftImageRightNews story={firstStory} aspectRatio={[16, 9]} imageType="image16x9" cssStyleName="bigSize" />
      )}
      <div>
        <div styleName="thumb-story-container">
          {stories.length > 1 && stories.splice(1, 4).map((item) => <NewsWithImage key={item.id} story={item} />)}
        </div>
      </div>
    </div>
  ) : null;
};

FiveVideoStories.propTypes = {
  collection: object,
  sections: array,
  domainSlug: string,
};

FiveVideoStories.storyLimit = 5;

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FiveVideoStories);
